import { ResponseDTO } from "../../interfaces/response"
import { TransactionUserPostDto } from "../../interfaces/transaction"
import HttpService from "../function/http"

export class TransactionServices {
    private _http = new HttpService()

    public async getTransactionsByUserId(dataBody: TransactionUserPostDto): Promise<ResponseDTO> {
        const response = await this._http.post(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/user`,
            dataBody
        )
        return response
    }
    public async getTransactionsDownloadByBusinessId(businessId: number): Promise<ResponseDTO> {
        const response = await this._http.get(
            `${process.env.REACT_APP_API_URL}`,
            `/transacction/invoices/${businessId}/download`
        )
        return response
    }
}